
export const mini = (imgPath, opts, density) => {
  var reg = /\.(png|jpg|gif|jpeg)$/;
  // 不常用格式不通过oss处理
  if (!reg.test(imgPath)) {
    return imgPath;
  }
  var img = imgPath + '?x-oss-process=image';
  if (opts.h || opts.m || opts.w || opts.p || opts.l || opts.s || opts.limit) {
    img += '/resize';
  }

  // 缩略的模式
  if (opts.m) {
    img = img + ',m_' + opts.m;
    if (opts.m === 'pad') {
      // 填充的颜色
      if (opts.color) {
        img = img + ',color_' + opts.color;
      }
    }
  }
  // 指定目标缩略图的宽度
  if (opts.w) {
    if (density) {
      opts.w = (opts.w * density).toFixed(0);
    }
    img = img + ',w_' + opts.w;
  }
  // 指定目标缩略图的高度
  if (opts.h) {
    if (density) {
      opts.h = (opts.h * density).toFixed(0);
    }
    img = img + ',h_' + opts.h;
  }
  // 指定目标缩略图的最长边
  if (opts.l) {
    img = img + ',l_' + opts.l;
  }
  // 指定目标缩略图的最短边
  if (opts.s) {
    img = img + ',s_' + opts.l;
  }
  // 指定当目标缩略图大于原图时是否处理,值是 1 表示不处理；值是 0 表示处理
  if (opts.limit !== undefined) {
    img = img + ',limit_' + opts.limit;
  }
  // 按比例缩放
  if (opts.p) {
    img = img + ',p_' + opts.p;
  }
  // 图片相对质量
  if (opts.q) {
    img = img + '/quality,q_' + opts.q;
  }
  // 图片绝对质量
  else if (opts.Q) {
    img = img + '/quality,Q_' + opts.Q;
  }
  // 图片格式 判断是否支持webp格式图片
  if (document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0) {
    img = img + '/format,webp';
  }
  return img;
};